export enum CompletionStatus {
  NotStarted = 0,
  InProgress = 1,
  Finished = 2,
}
